import { DecimalPipe } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PaginierungDplComponent } from '../../paginierung/paginierung-dpl/paginierung-dpl.component';

@Component({
  selector: 'now-wbsuche-lib-termin-tabelle-paginierung',
  templateUrl: './termin-tabelle-paginierung.component.html',
  imports: [PaginierungDplComponent, DecimalPipe]
})
export class TerminTabellePaginierungComponent {
  @Input()
  public totalItems!: number;

  @Input()
  public currentPage!: number;

  @Input()
  public pageSize!: number;

  @Output()
  public currentPageChange = new EventEmitter<number>();

  get anzahlSeiten(): number {
    return Math.ceil(this.totalItems / this.pageSize);
  }

  public pageFirstClicked(): void {
    this.setAktuelleSeite(1);
  }

  public pagePrevClicked(): void {
    if (this.currentPage > 1) {
      this.setAktuelleSeite(this.currentPage - 1);
    }
  }

  public pageNextClicked(): void {
    if (this.currentPage < this.anzahlSeiten) {
      this.setAktuelleSeite(this.currentPage + 1);
    }
  }

  public pageLastClicked(): void {
    this.setAktuelleSeite(this.anzahlSeiten);
  }

  public threePagesBackwards(): void {
    if (this.currentPage - 2 > 1) {
      this.setAktuelleSeite(this.currentPage - 3);
    }
  }

  public threePagesForwards(): void {
    if (this.currentPage + 2 < this.anzahlSeiten) {
      this.setAktuelleSeite(this.currentPage + 3);
    }
  }

  get ersterTreffer(): number {
    return (this.currentPage - 1) * this.pageSize + 1;
  }

  get letzterTreffer(): number {
    return Math.min(this.currentPage * this.pageSize, this.totalItems);
  }

  private setAktuelleSeite(aktuelleSeite: number): void {
    this.currentPage = aktuelleSeite;
    this.currentPageChange.next(this.currentPage);
  }
}
